const keyMirror = require("keymirror");

export const StoresConstants = keyMirror({
  FETCH_STORES: undefined,
  FETCH_STORE_BY_ID: undefined,
  FETCH_STORE_DASHBOARD: undefined,
  UPDATE_STORE_DETAILS: undefined
});
